import React, { useEffect } from "react";
import PropTypes from "prop-types";
import useAuth from "src/hooks/useAuth";
import { PATH_APP, PATH_HOME } from "src/routes/paths";
import { Redirect } from "react-router-dom";
import LoadingScreen from "src/components/LoadingScreen";
import { useSelector } from "react-redux";
import Roles from "src/utils/Roles";
import IsRole from "src/utils/IsRole";
import EnumErrorCodes from "src/utils/errors/EnumErrorCodes";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import axios from "src/utils/axios";
import {
  getAdminNotificationsSuccess,
  showModalNotificationStartup,
} from "src/redux/slices/notifications";
import { useDispatch } from "src/redux/store";

// ----------------------------------------------------------------------

GuestProtect.propTypes = {
  children: PropTypes.node,
};

function GuestProtect({ children }) {
  const dispatch = useDispatch();
  const { isLoading, isAuthenticated, isSessionAuthenticated } = useAuth();
  const { claims, user } = useSelector((state) => state.authJwt);
  const { currentActiveEmployee } = useSelector((state) => state.employees);
  const { pathname } = useLocation();

  useEffect(async () => {
    if (isAuthenticated) {
      if (
        !IsRole(claims.role, Roles.GLOBAL_ADMIN) &&
        IsRole(claims.role, Roles.USER_NORMAL) &&
        !IsRole(claims.role, Roles.USER_EMPLOYEE)
      ) {
        axios.get(`notificaciones/readAdmin`).then((res) => {
          var notifications = res.data;

          if (
            notifications?.filter((u) => u.isUnRead && u.isMandatory)?.length >
            0
          ) {
            dispatch(showModalNotificationStartup(true));
            dispatch(getAdminNotificationsSuccess(notifications));
          }
        });
      }
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    const employee = Number(window.localStorage.getItem("UserEmployeeId"));

    if (!employee && !currentActiveEmployee)
      window.localStorage.setItem("UserEmployeeId", 0);
    else if (employee !== currentActiveEmployee)
      window.localStorage.setItem("UserEmployeeId", currentActiveEmployee);

    if (IsRole(claims.role, Roles.USER_FRANQUICIA))
      return <Redirect to={PATH_APP.franquicia.root} />;

    if (IsRole(claims.role, Roles.USER_FRANQUICIADO))
      return <Redirect to={PATH_APP.franquiciado.root} />;

    if (IsRole(claims.role, Roles.GLOBAL_ADMIN))
      return <Redirect to={PATH_APP.admin.root} />;

    if (IsRole(claims.role, Roles.USER_DISTRIBUTOR)) {
      return <Redirect to={PATH_APP.admin.root} />;
    }

    if (new Date(user?.finishDemoTrial) < new Date())
      return (
        <Redirect
          to={`${PATH_APP.user.account}/${EnumErrorCodes.FinishLicenceTrialCode}`}
        />
      );

    if (IsRole(claims.role, Roles.USER_NORMAL)) {
      if (user?.isOnlyTpv) return <Redirect to={PATH_APP.tpv.cartaCamarero} />;

      return <Redirect to={PATH_APP.tuCarta.root} />;
    }

    return <Redirect to="/404" />;
  }

  const isAuthPath =
    pathname.includes("auth/login") ||
    pathname.includes("auth/employee") ||
    pathname.includes("register");

  if (isSessionAuthenticated && !isAuthPath)
    return <Redirect to={PATH_HOME.tucarta.root} />;

  return <>{children}</>;
}

export default GuestProtect;
